exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconStyle{top:18%;right:0;border-radius:50%;background-color:#e6f2fd;border:1px solid #ced4da;width:30px;height:30px;display:flex;justify-content:center;align-items:center}.MandatoryStyle{background-color:#fde6e6}.selectStyle{font-size:12px;height:38px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58e81320","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListBaseAcc/Components/AddNewBaseAcc.vue
// module id = 594
// module chunks = 0